class SearchPanel {
    constructor() {
        const searchPanel = document.getElementById('search-panel');

        searchPanel.addEventListener('shown.bs.offcanvas', () => {
            searchPanel.querySelector('.form-control').focus();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new SearchPanel();
});